// eslint-disable-next-line
export const ACTION_PREFIX = 'app/';
export const SITE_URL = window.siteUrl;
export const SCREEN_ID = window.screenId;
export const ERROR_POLLING_INTERVAL = 60;
// MESSAGES
export const MSG_BLOCK = 'MSG_BLOCK';
export const MSG_TIME = 'MSG_TIME';
export const MSG_UNBLOCK = 'MSG_UNBLOCK';
// PLAYERS
export const TRANSITION = 'TRANSITION';
export const TRANSITION2 = 'TRANSITION2';
export const IMAGES = 'IMAGES';
export const MEDIA_DECKS = 'MEDIA_DECKS';
export const RESTART_DELAY = 2;
export const WEBS = 'WEBS';
export const YOUTUBE_VIDEOS = 'YOUTUBE_VIDEOS';



// WEBPACK FOOTER //
// ./src/strings.js